// extracted by mini-css-extract-plugin
module.exports = {"box":"HatchCTA_box__2NK5p","body":"HatchCTA_body__NCyE3","textContainer":"HatchCTA_textContainer__1lTYK","link":"HatchCTA_link__27ugT","button":"HatchCTA_button__1gv-u"};